import { render, staticRenderFns } from "./VProcessRatingList.vue?vue&type=template&id=332bc11c&"
import script from "./VProcessRatingList.vue?vue&type=script&lang=js&"
export * from "./VProcessRatingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports